import { Spacer } from '@porsche-code/kado-ui';
import { PHeading, PLink } from '@porsche-design-system/components-react';
import { useTranslation } from 'react-i18next';

export const UserFeedback = ({ url }: { url?: string }) => {
  const { t } = useTranslation();
  return (
    <>
      <PHeading size="sm" aria-level={5} tag="h5">
        {t('admin.announcement.userFeedback')}
      </PHeading>
      <p>{t('admin.announcement.userFeedbackText')}</p>
      {url && (
        <>
          <Spacer mb="sm" />
          <PLink
            compact
            icon="external"
            variant="secondary"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('admin.announcement.userFeedbackButton')}
          >
            {t('admin.announcement.userFeedbackButton')}
          </PLink>
        </>
      )}
    </>
  );
};
